import { schema } from 'normalizr'

export const user = new schema.Entity('users')
export const frameType = new schema.Entity('frameTypes')
export const sale = new schema.Entity('sales', {}, {
  idAttribute: (value) => `${value.orderId}-${value.productSku}`
})
export const size = new schema.Entity('sizes')
export const tag = new schema.Entity('tags')
export const artwork = new schema.Entity('artworks', {
  tags: [ tag ]
})



// WEBPACK FOOTER //
// ./src/redux/actions/schema.js